import { queryOptions, useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const cardOverridesQueryOptions = queryOptions({
  queryKey: ['card-overrides'],
  queryFn: async () => {
    const now = new Date().toISOString();
    const { data, error } = await supabase
      .from('card_overrides')
      .select('*')
      .or(`effective_from.is.null,effective_from.lte.${now}`)
      .or(`effective_to.is.null,effective_to.gte.${now}`);

    if (error) throw error;
    return data || [];
  },
  staleTime: 5 * 60 * 1000,
  gcTime: 15 * 60 * 1000,
});

export const useCardOverrides = () => useQuery(cardOverridesQueryOptions);
